import type React from 'react';
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazyMeetingRequest = lazy(() => import('./MeetingRequest'));

const MeetingRequest = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={<PageLoading />}>
    <LazyMeetingRequest {...props} />
  </Suspense>
);

export const meetingRequestRoute = {
  path: '/meeting-request/:key',
  element: <MeetingRequest />,
} as RouteObject;

export default MeetingRequest;
